<br>
<div class="col-lg-12">
  <h4 style="text-align: center;">REPORTE DE DEUDAS - CONSULTA POR CUIT Y/O PERIODO</h4>
  <br>
  <div>
    <label for="cuit">CUIT (opcional):</label>&nbsp;
    <app-cuit-input [(ngModel)]="filtroCuit" name="filtroCuit" inputStyle="width: 130px;"></app-cuit-input>
    &nbsp;
    <label for="perdes">PERI DESDE:</label>&nbsp;
    <input maxlength="5" style="width: 60px;" type="text" name="filtroPeriodoDesde" [(ngModel)]="filtroPeriodoDesde" placeholder="YY/MM">
    &nbsp;
    <label for="perhas">PERI HASTA:</label>&nbsp;
    <input maxlength="5" style="width: 60px;" type="text" name="filtroPeriodoHasta" [(ngModel)]="filtroPeriodoHasta" placeholder="YY/MM">
    &nbsp;
    <label for="filtroEstado">ESTADO:</label>&nbsp;
    <select name="filtroEstadoPago" [(ngModel)]="filtroEstadoPago" style="width: 120px;">
      <option value="todos">TODOS</option>
      <option value="pagados">SOLO PAGOS</option>
      <option value="impagos">SOLO IMPAGOS</option>
    </select>
    &nbsp;
    <label for="filtroCodconc">CONCEPTO:</label>&nbsp;
    <select name="filtroCodconc"
            [(ngModel)]="filtroCodconc"
            (change)="aplicarFiltroCodconc()"
            [disabled]="!dataSourceCompleto || dataSourceCompleto.length === 0"
            style="width: 280px;">
      <option value="">TODOS</option>
      <option *ngFor="let opt of getCodconcOptions()" [value]="opt.codconc">
        {{opt.codconc}} - {{opt.descripcion}}
      </option>
    </select>
    &nbsp;
    <button [disabled]="(filtroPeriodoDesde.length < 5) || (filtroPeriodoHasta.length < 5)"
            type="button" class="btn btn-primary"
            (click)="buscarDeudas()">
       <span *ngIf="loading==false">CONSULTAR DEUDAS</span>
       <span *ngIf="loading==true">PROCESANDO...</span>
       <i *ngIf="loading" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
    </button>
    &nbsp;

    <button [disabled]="totalRecords == 0 || loadingExcel"
            type="button" class="btn btn-success"
            (click)="exportarExcel()">
      <i *ngIf="!loadingExcel" class="fa fa-file-excel-o" aria-hidden="true"></i>
      <i *ngIf="loadingExcel" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
      &nbsp;
      <span>{{loadingExcel ? 'EXPORTANDO...' : 'EXPORTAR A EXCEL'}}</span>
    </button>
    &nbsp;

    <button type="button" class="btn btn-secondary" (click)="limpiarFiltros()">
      <i class="fa fa-eraser" aria-hidden="true"></i>
      &nbsp;
      <span>LIMPIAR</span>
    </button>

  </div>

  <hr>

  <!-- TABLA PRINCIPAL: Deudas -->
  <div *ngIf="dataSource != null && dataSource.length > 0" class="animated fadeIn">
    <h5>
      Resultados de Consulta:
      <span *ngIf="filtroEstadoPago === 'todos'">{{dataSource.length}} registros (mostrando página {{pageIndex + 1}})</span>
      <span *ngIf="filtroEstadoPago === 'pagados'" style="color: green;">{{dataSource.length}} PAGOS</span>
      <span *ngIf="filtroEstadoPago === 'impagos'" style="color: red;">{{dataSource.length}} PERÍODOS IMPAGOS</span>
    </h5>

    <!-- Paginador custom superior -->
    <div class="custom-paginator">
      <!-- Total de registros -->
      <div class="paginator-total">
        <span class="badge badge-primary">Total: {{totalRecords}} registros</span>
      </div>

      <!-- Selector de tamaño de página -->
      <div class="paginator-page-size">
        <label>Registros por página:&nbsp;</label>
        <select [(ngModel)]="pageSize" (change)="changePageSize(pageSize)" class="form-control form-control-sm" style="width: auto; display: inline-block;">
          <option [value]="100">100</option>
          <option [value]="500">500</option>
          <option [value]="1000">1000</option>
          <option [value]="2000">2000</option>
        </select>
      </div>

      <!-- Botones de navegación -->
      <div class="paginator-navigation">
        <!-- First -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex === 0"
                (click)="goToPage(0)"
                title="Primera página">
          <i class="fa fa-angle-double-left"></i>
        </button>

        <!-- Previous -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex === 0"
                (click)="goToPage(pageIndex - 1)"
                title="Página anterior">
          <i class="fa fa-angle-left"></i>
        </button>

        <!-- Números de página -->
        <span *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'"
                  class="btn btn-sm"
                  [class.btn-primary]="page === pageIndex"
                  [class.btn-outline-secondary]="page !== pageIndex"
                  (click)="goToPage(page)">
            {{page + 1}}
          </button>
          <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
        </span>

        <!-- Next -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex >= getTotalPages() - 1"
                (click)="goToPage(pageIndex + 1)"
                title="Página siguiente">
          <i class="fa fa-angle-right"></i>
        </button>

        <!-- Last -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex >= getTotalPages() - 1"
                (click)="goToPage(getTotalPages() - 1)"
                title="Última página">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </div>

    <div class="tabla-wrapper">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 animated fadeIn">

      <!-- Columna: CUIT Contribuyente -->
      <ng-container matColumnDef="cuitcont">
        <th mat-header-cell *matHeaderCellDef> CUIT </th>
        <td mat-cell *matCellDef="let element"> {{element.cuitcont}} </td>
      </ng-container>

      <!-- Columna: Periodo -->
      <ng-container matColumnDef="periodo">
        <th mat-header-cell *matHeaderCellDef> PERIODO </th>
        <td mat-cell *matCellDef="let element"> {{element.periodo}} </td>
      </ng-container>

      <!-- Columna: Codigo Concepto -->
      <ng-container matColumnDef="codconc">
        <th mat-header-cell *matHeaderCellDef> COD </th>
        <td mat-cell *matCellDef="let element"> {{element.codconc}} </td>
      </ng-container>

      <!-- Columna: Descripcion -->
      <ng-container matColumnDef="descripcion_concepto">
        <th mat-header-cell *matHeaderCellDef> DESCRIPCION </th>
        <td mat-cell *matCellDef="let element"> {{element.descripcion_concepto}} </td>
      </ng-container>

      <!-- Columna: Debito/Credito -->
      <ng-container matColumnDef="inddbcr">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> D/C </th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <span [style.color]="element.inddbcr === 'D' ? 'red' : 'green'">
            {{element.inddbcr}}
          </span>
        </td>
      </ng-container>

      <!-- Columna: Importe -->
      <ng-container matColumnDef="importe">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> IMPORTE </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;"> {{element.importe | currency:"$"}} </td>
      </ng-container>

      <!-- Columna: Fecha Proceso -->
      <ng-container matColumnDef="fecproc">
        <th mat-header-cell *matHeaderCellDef> FEC PROC </th>
        <td mat-cell *matCellDef="let element"> {{element.fecproc | date:'dd/MM/yyyy'}} </td>
      </ng-container>

      <!-- Columna: Fecha Recaudacion -->
      <ng-container matColumnDef="fecrec">
        <th mat-header-cell *matHeaderCellDef> FEC REC </th>
        <td mat-cell *matCellDef="let element"> {{element.fecrec | date:'dd/MM/yyyy'}} </td>
      </ng-container>

      <!-- Columna: CUIT Aportante -->
      <ng-container matColumnDef="cuitapo">
        <th mat-header-cell *matHeaderCellDef> CUIT APORTANTE </th>
        <td mat-cell *matCellDef="let element"> {{element.cuitapo}} </td>
      </ng-container>

      <!-- Columna: Remuneración Imponible (BASE DE CALCULO) -->
      <ng-container matColumnDef="deuda_nomina">
        <th mat-header-cell *matHeaderCellDef style="text-align: right;"> REMUNERACIÓN IMPONIBLE </th>
        <td mat-cell *matCellDef="let element" style="text-align: right;">
          <strong>{{element.deuda_nomina | currency:"$"}}</strong>
        </td>
      </ng-container>

      <!-- Columna: Tiene Pago -->
      <ng-container matColumnDef="tiene_pago">
        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> ESTADO </th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <span [style.color]="element.tiene_pago === 1 ? 'green' : 'red'"
                [style.font-weight]="'bold'">
            {{element.tiene_pago === 1 ? 'PAGADO' : 'IMPAGO'}}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>

    <!-- Paginador custom inferior -->
    <div class="custom-paginator">
      <!-- Total de registros -->
      <div class="paginator-total">
        <span class="badge badge-primary">Total: {{totalRecords}} registros</span>
      </div>

      <!-- Selector de tamaño de página -->
      <div class="paginator-page-size">
        <label>Registros por página:&nbsp;</label>
        <select [(ngModel)]="pageSize" (change)="changePageSize(pageSize)" class="form-control form-control-sm" style="width: auto; display: inline-block;">
          <option [value]="100">100</option>
          <option [value]="500">500</option>
          <option [value]="1000">1000</option>
          <option [value]="2000">2000</option>
        </select>
      </div>

      <!-- Botones de navegación -->
      <div class="paginator-navigation">
        <!-- First -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex === 0"
                (click)="goToPage(0)"
                title="Primera página">
          <i class="fa fa-angle-double-left"></i>
        </button>

        <!-- Previous -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex === 0"
                (click)="goToPage(pageIndex - 1)"
                title="Página anterior">
          <i class="fa fa-angle-left"></i>
        </button>

        <!-- Números de página -->
        <span *ngFor="let page of getPageNumbers()">
          <button *ngIf="page !== '...'"
                  class="btn btn-sm"
                  [class.btn-primary]="page === pageIndex"
                  [class.btn-outline-secondary]="page !== pageIndex"
                  (click)="goToPage(page)">
            {{page + 1}}
          </button>
          <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
        </span>

        <!-- Next -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex >= getTotalPages() - 1"
                (click)="goToPage(pageIndex + 1)"
                title="Página siguiente">
          <i class="fa fa-angle-right"></i>
        </button>

        <!-- Last -->
        <button class="btn btn-sm btn-outline-secondary"
                [disabled]="pageIndex >= getTotalPages() - 1"
                (click)="goToPage(getTotalPages() - 1)"
                title="Última página">
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mensaje cuando NO hay resultados -->
  <div *ngIf="dataSource != null && dataSource.length == 0" class="animated fadeIn">
    <br>
    <div class="alert alert-info" role="alert">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      No se encontraron resultados para los filtros especificados.
    </div>
  </div>


</div>
<br><br>
